export default __webpack_public_path__ + "static/media/foresta.cc490fe8.png";